import React, { useCallback, useEffect, useState } from 'react'
import {
  View,
  Text,
  ActivityIndicator,
  StyleSheet,
  ScrollView,
  TouchableOpacity
} from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigation, useRoute } from '@react-navigation/native'

import PropertySearch from '../../../components/maintainance/PropertySearch'
import AddNewIssueModal from '../../../components/maintainance/AddNewIssueModal'

import {
  getFlow,
  getRoomTypes,
  getCatogoriesTypes
} from '../../../redux/action/maintenance.actions'

import { showErrorToast } from '../../tenants/tenantOnboarding/helpers'
import drawerHoc from '../../../components/drawerHOC/DrawerHOC'
import PersonCard from '../../../components/maintainance/PersonCard'
import AccordionSection from '../../../components/maintainance/AccordionSection'
import NewIssueTable from './NewIssueTable'
import Timeline from '../../../components/maintainance/Timeline'
import { COLORS } from '../../tenants/tenantOnboarding/screens/components/PropertyDetailsCard'
import { Feather } from '@expo/vector-icons'
import getPlatformType from '../../../helpers/helpers'
import EditIssueModal from '../../../components/maintainance/EditIssueModal'
import TableShimmer from '../../../components/maintainance/TableShimmer'
const layout = getPlatformType()
const New_issue_openflow_id = ({ openflow_id_props, showCompletePage = true, onProjectCreated }) => {

  const route = useRoute()
  const openflow_id = openflow_id_props ?? route?.params?.id
  const [selectedItems, setSelectedItems] = useState<any>(null)
  const navigation = useNavigation()
  const dispatch = useDispatch()
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [flowData, setFlowData] = useState<any>(null)



  /* ---------------- FETCH FLOW ---------------- */
  const { issuesList, issuesListTotalCount } = useSelector(
    (state) => state.maintenance
  )
  const pageCount = Math.ceil(issuesListTotalCount / 10)
  useEffect(() => {
    setFlowData(issuesList)
  }, [issuesList])
  const fetchFlow = useCallback(async () => {
    try {
      setLoading(true)

      await dispatch(
        getFlow({
          flow_id: Number(openflow_id),
          offset: (page - 1),
          callBack: (data: any) => {
          }
        })
      )

    } catch (error) {
      showErrorToast('Failed to fetch flow')
    } finally {
      setLoading(false)
    }
  }, [dispatch, openflow_id, page])

  useEffect(() => {
    dispatch(getRoomTypes())
    dispatch(getCatogoriesTypes())
  }, [dispatch])

  useEffect(() => {
    if (openflow_id) {
      fetchFlow()
    }
  }, [fetchFlow, page])

  const handleView = (issue: any) => {
    navigation.navigate('IssueDetails', {
      id: issue?.open_flow_maintenance_issue_id
    })
  }

  if (loading || !flowData) {
    return (

         <TableShimmer rows={6} />

    )
  }
  const handlePageChange = (value) => {
    setPage(value)
  }
  return (
    <ScrollView style={styles.container}>


      {showCompletePage ? <Text style={styles.address}>
        {flowData?.displayAddress}
      </Text> :
        <View
          style={[
            styles.registerBox,
            layout !== "web" && styles.registerBoxMobile
          ]}
        >
          <View style={{ flex: 1 }}>
            <Text style={styles.registerTitle}>Register new issue</Text>

            <Text style={styles.registerDesc}>
              If your tenant notified you outside the system,
              click "Add Issue" and follow the process.
            </Text>
          </View>

          <TouchableOpacity
            style={[
              styles.addIssueButton,
              layout !== "web" && styles.addIssueButtonMobile
            ]}
            onPress={() => setOpenModal(true)}
          >
            <Feather name="plus-circle" size={18} color="#fff" />
            <Text style={styles.addIssueText}>ADD ISSUE</Text>
          </TouchableOpacity>
        </View>}
      {showCompletePage ? <AccordionSection
        title="Tenants & Landlords"
        count={
          (flowData?.tenants?.length || 0) +
          (flowData?.landlords?.length || 0)
        }
      >

        {/* TENANTS SUB SECTION */}
        {flowData?.tenants?.length > 0 && (
          <>
            <View style={styles.subHeader}>
              <Text style={styles.subTitle}>Tenants</Text>
              <View style={styles.subBadge}>
                <Text style={styles.subBadgeText}>
                  {flowData?.tenants?.length}
                </Text>
              </View>
            </View>

            <View style={styles.cardGrid}>
              {flowData?.tenants?.map((tenant: any) => {
                const user = tenant?.app_user?.user

                return (
                  <View
                    key={tenant.open_flow_sub_tenant_id}
                    style={styles.cardWrapper}
                  >
                    <PersonCard
                      firstName={user?.first_name}
                      lastName={user?.last_name}
                      email={user?.email}
                      postcode={user?.postcode}
                      contact={user?.contact_number}
                      isLead={tenant?.is_lead}
                    />
                  </View>
                )
              })}
            </View>
          </>
        )}

        {/* DIVIDER */}
        {flowData?.tenants?.length > 0 &&
          flowData?.landlords?.length > 0 && (
            <View style={styles.divider} />
          )}

        {/* LANDLORDS SUB SECTION */}
        {flowData?.landlords?.length > 0 && (
          <>
            <View style={styles.subHeader}>
              <Text style={styles.subTitle}>Landlords</Text>
              <View style={styles.subBadge}>
                <Text style={styles.subBadgeText}>
                  {flowData?.landlords?.length}
                </Text>
              </View>
            </View>

            <View style={styles.cardGrid}>
              {flowData?.landlords?.map((landlord: any) => (
                <View
                  key={landlord.open_flow_landlord_id}
                  style={styles.cardWrapper}
                >
                  <PersonCard
                    firstName={landlord?.first_name}
                    lastName={landlord?.last_name}
                    email={landlord?.email}
                    postcode={landlord?.post_code}
                    contact={landlord?.number}
                    isLead={landlord?.is_lead}
                  />
                </View>
              ))}
            </View>
          </>
        )}

      </AccordionSection> : false}

      <NewIssueTable
        slelfManageCallback={!showCompletePage}
        flos={flowData?.issues || []}
        flototal={flowData?.issues?.length || 0}
        handlePageChange={handlePageChange}
        pageCount={pageCount}
        page={page}
        onView={handleView}
        refresh={fetchFlow}
        onAdd={() => setOpenModal(true)}
        editView={(item) => {
          setSelectedItems(item)
          setOpenModal(true)
        }}
        openflow_id={openflow_id}
        onSelfManageSuccess={() => {
          onProjectCreated()
        }}

      />
      {flowData?.comments && flowData?.comments?.length ? <Timeline data={flowData?.comments} /> : null}

      <EditIssueModal
        slectedItems={selectedItems}
        flowId={openflow_id}
        open={openModal}
        onClose={() => setOpenModal(false)}
        onIssueAdded={() => {
          setOpenModal(false)
          fetchFlow()
        }}
      />

    </ScrollView>
  )
}

// ================= CONDITIONAL EXPORT =================

const WrappedComponent = drawerHoc({
  Component: New_issue_openflow_id,
  showBackButton: true,
  customWidth: "70%",
})

export default function ExportComponent(props: any) {
  // If showCompletePage is false → don't use drawerHoc
  if (props?.showCompletePage === false) {
    return <New_issue_openflow_id {...props} />
  }

  // Otherwise use drawer HOC
  return <WrappedComponent {...props} />
}


const styles = StyleSheet.create({

  addIssueButtonMobile: {
    width: "100%",
    justifyContent: "center",
    marginTop: 10,
  },
  registerBoxMobile: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 15,
  },
  headerTitle: {
    fontSize: layout === "web" ? 26 : 22,
    fontWeight: "700",
    color: "#7D57C1",
    marginBottom: 10,
  },
  emailText: {},
  headerSubtitle: {
    fontSize: layout === "web" ? 15 : 14,
    color: "#6B7280",
    lineHeight: 22,
    marginBottom: 25,
  },

  pageWrapper: {
    flex: 1,
  },
  headerCard: {
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: 18,
    marginBottom: 30,
    shadowColor: "#000",
    shadowOpacity: 0.08,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 4 },
    elevation: 3,
  },
  registerBox: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10
  },

  registerTitle: {
    fontSize: 18,
    fontWeight: "600",
    marginBottom: 5,
  },

  registerDesc: {
    fontSize: 14,
    color: "#6B7280",
  },

  addIssueButton: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: COLORS.primary,
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 30,
    gap: 8,
  },

  addIssueText: {
    color: "#fff",
    fontWeight: "600",
    letterSpacing: 1,
  },

  subHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,

  },

  subTitle: {
    fontSize: 15,
    fontWeight: "700",
    color: "#111827",
  },

  subBadge: {
    marginLeft: 10,
    backgroundColor: "#E9D8F7",
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 20,
  },

  subBadgeText: {
    color: "#6D08C0",
    fontSize: 12,
    fontWeight: "600",
  },

  divider: {
    height: 1,
    backgroundColor: "#F3F4F6",
    marginVertical: 10,
  },

  cardGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
  },

  cardWrapper: {
    width: 320,
    marginRight: 16,
    marginBottom: 8,
  },

  container: {
    flex: 1,
    padding: 20,
  },

  center: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },

  address: {
    fontSize: 20,
    fontWeight: '700',
    color: COLORS.primary,
    marginBottom: 25,
  },

  section: {
    marginBottom: 30,
  },

  sectionTitle: {
    fontSize: 16,
    fontWeight: '700',
    marginBottom: 15,
    color: '#111827'
  },

})
